import { ChangeEvent, MouseEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu as MenuIcon, KeyboardArrowRight } from '@mui/icons-material';
import {
  FormControlLabel,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';

import { RouteEnum, generateRoutePath, useSession } from 'App';
import { Nullable, StatusesAPI } from '@shared';

import * as S from './StatusesMenu.styled';
import { StatusesMenuPropsType } from './StatusesMenu.types';

export const StatusesMenu = (props: StatusesMenuPropsType) => {
  const {
    isNotificationShowing = false,
    auditUuid,
    openReviewIdentity,
    useStatuses,
    isReview = false,
    openComments,
    sessionUuid,
  } = props;
  const { statuses, updateStatuses, isStatusesLoading } = useStatuses;
  const { currentUser } = useSession();
  const { isLeadAuditor } = currentUser.roles;

  const [anchorEl, setAnchorEl] = useState<Nullable<HTMLElement>>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleChange = (field: keyof StatusesAPI) => (event: ChangeEvent<HTMLInputElement>) => {
    updateStatuses({ auditUuid, statuses: { ...statuses, [field]: event.target.checked } });
  };
  const handleClickReview = () => {
    handleClose();
    openReviewIdentity();
  };
  const handleClickComments = () => {
    openComments && openComments();
  };
  return (
    <>
      <IconButton onClick={handleClick} sx={{ alignSelf: 'flex-end' }}>
        <S.Badge variant='dot' overlap='circular' invisible={!isNotificationShowing}>
          <MenuIcon sx={{ width: 32, height: 32 }} />
        </S.Badge>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={S.MenuPaperProps}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <S.MenuItem isBordered={isLeadAuditor} onClick={handleClickReview}>
          <S.MenuItemLabel isVisible={isNotificationShowing}>Review Identity</S.MenuItemLabel>
          <ListItemIcon sx={{ justifyContent: 'flex-end' }}>
            <KeyboardArrowRight fontSize='small' />
          </ListItemIcon>
        </S.MenuItem>

        {isReview && (
          <S.MenuItem onClick={handleClickComments}>
            <Typography>Comments</Typography>
          </S.MenuItem>
        )}
        {isReview && (
          <Link
            to={generateRoutePath({
              name: RouteEnum.TargetReport,
              params: { session: sessionUuid },
            })}
            style={{ textDecoration: 'none' }}
            target='_blank'
            rel='noopener noreferrer'
          >
            <S.MenuItem>
              <Typography>Target Report</Typography>
            </S.MenuItem>
          </Link>
        )}

        {isLeadAuditor && (
          <MenuItem>
            <FormControlLabel
              control={
                <S.Checkbox
                  disabled={isStatusesLoading}
                  checked={statuses?.needsReview}
                  onChange={handleChange('needsReview')}
                />
              }
              label='Under Review'
            />
          </MenuItem>
        )}

        {isLeadAuditor && (
          <MenuItem>
            <FormControlLabel
              control={
                <S.Checkbox
                  disabled={isStatusesLoading}
                  checked={statuses?.auditOfInterest}
                  onChange={handleChange('auditOfInterest')}
                />
              }
              label='Audit of Interest'
            />
          </MenuItem>
        )}
      </Menu>
    </>
  );
};
